<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActive"
  >
    <div id="loading-update-compliance-expiration-sidebar" class="vs-con-loading__container">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4> {{$t('update')}} {{$t('expiration')}}</h4>
        <feather-icon icon="XIcon" @click.stop="close" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="p-6">
          <!-- <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('expiration_date')}}</label>
              <vs-input
                class="w-full"
                type="text"
                v-mask="'##/##/####'"
                v-model="expirationDate"
                name="expirationDate"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('expirationDate')"
              >{{ errors.first('expirationDate') }}</span>
            </div>
          </div> -->
          <input-date 
              v-model="expirationDate" 
              :value="expirationDate"
              :label="$t('expiration_date')" />

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('notify')}} ({{$t('days')}})</label>
              <vs-input-number
                min="1"
                v-model="notifyDays"
                name="notifyDays"
                class="w-full"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('notifyDays')"
              >{{ errors.first('notifyDays') }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('term')}} ({{$t('months')}})</label>
              <vs-input-number
                min="1"
                v-model="term"
                name="term"
                class="w-full"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('term')"
              >{{ errors.first('term') }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('escalation_rate')}} (%)</label>
              <vs-input
                v-model="escalationRate"
                name="escalationRate"
                class="w-full"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('escalationRate')"
              >{{ errors.first('escalationRate') }}</span>
            </div>
          </div>

          <template v-if="extraFields">
              <input-date 
              v-model="extensionDate" 
              :value="extensionDate"
              :label="$t('extension_date')" />
            
            <!-- <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label>{{$t('extension_date')}}</label>
                <vs-input
                  class="w-full"
                  type="text"
                  v-mask="'##/##/####'"
                  v-model="extensionDate"
                  name="extensionDate"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('extensionDate')"
                >{{ errors.first('extensionDate') }}</span>
              </div>
            </div> -->

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label>{{$t('escalation_period')}}</label>
                <vs-input
                  class="w-full"
                  type="number"
                  v-model="escalationPeriod"
                  name="escalationPeriod"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('escalationPeriod')"
                >{{ errors.first('escalationPeriod') }}</span>
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label>{{$t('options')}}</label>
                <vs-input
                  class="w-full"
                  type="text"
                  v-model="options"
                  name="options"
                  :placeholder="$t('options')"
                />
              </div>
            </div>
          </template>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('file')}}</label>
              <input
                type="file"
                name="file"
                label="File"
                ref="file"
                class="w-full"
                @change="changeFile"
              />
            </div>
          </div>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button
          class="mr-6"
          @click.stop.prevent="submit()"
          :disabled="!validForm"
        >{{$t('submit')}}</vs-button>
        <vs-button type="border" color="danger" @click.stop="close">{{$t('cancel')}}</vs-button>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import compliance from '@/http/requests/compliance'
import InputDate from '@/components/custom/InputDate.vue'

export default {
  props:['compliance'],
  data() {
    return {
      extraFields:false,
      expirationDate:'',
      notifyDays:0,
      term:0,
      escalationRate:0,
      file:'',
      extensionDate:'',
      escalationPeriod:0,
      options:'',
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === 'updateComplianceExpiration'
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    validForm() {
      return this.file !== ''
    }
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      this.extraFields = false;
      this.expirationDate = this.compliance.expiration_date
      this.notifyDays = this.compliance.notify_days
      this.term = this.compliance.term
      this.escalationRate = this.compliance.escalation_rate
      this.file = ''
      this.$refs.file.value = ''
      if(this.compliance.type_id == '1'){
        this.extraFields = true
        this.extensionDate = this.compliance.extension_date
        this.escalationPeriod = this.compliance.escalation_period
        this.options = this.compliance.options
      }
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    submit() {
    this.openLoading()
      let form = new FormData()
      form.append('compliance',this.compliance.id)
      form.append('expiration_date',this.expirationDate)
      form.append('notify_days',this.notifyDays)
      form.append('term',this.term)
      form.append('escalation_rate',this.escalationRate)
      form.append('file',this.file)
      
      if(this.extraFields){
        form.append('extra_fields',this.extraFields)
        form.append('extension_date',this.extensionDate)
        form.append('escalation_period',this.escalationPeriod)
        form.append('options',this.options)
      }
      this.$store.dispatch('compliance/updateExpiration', form)
      .then(res => {
          this.$store.dispatch('getNotifications')
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Added'
          })
          this.closeLoading()
          this.close()
        })
        .catch(err => {
          this.closeLoading()
          if (422 === err.response.status) {
            let errors = err.response.data.errors
            let errorArray = Object.keys(errors).map(function (key) {
              return [key, errors[key]]
            })
            errorArray.forEach(element => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0]
              })
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR'
            })
          }
        })
    },
    openLoading() {
      this.$vs.loading({
        container: '#loading-update-compliance-expiration-sidebar',
        scale: 0.6
      })
    },
    closeLoading() {
      this.$vs.loading.close('#loading-update-compliance-expiration-sidebar > .con-vs-loading')
    },
    changeFile () {
      this.file = this.$refs.file.files[0]
    },
  },
  components: {
    VuePerfectScrollbar,
    InputDate
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
